/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { VariantFilterValueSchemaMode } from './variantFilterValueSchemaMode';
import type { VariantFilterValueSchemaScope } from './variantFilterValueSchemaScope';

/**
 * FilterValueSchema for fields whose chips may carry `variants`.
 */
export interface VariantFilterValueSchema {
  canonical_id?: number | null;
  text?: string | null;
  mode?: VariantFilterValueSchemaMode;
  required?: boolean;
  scope?: VariantFilterValueSchemaScope;
  variants?: string[] | null;
}
